import React from 'react';
import Select from 'react-select';
import { selectStyles } from './selectStyles';

/**
 * Simple wrapper around react-select that exposes a controlled multi select.
 * The `value` prop is expected to be an array of primitive values. The
 * component maps those values to the provided options and returns the selected
 * values (not the option objects) via `onChange`.
 */
export const MultiSelect = ({ options = [], value = [], onChange, styles, ...props }) => {
  const selectedOptions = options.filter((o) => value.includes(o.value));

  const handleChange = (vals) => {
    onChange && onChange(vals ? vals.map((v) => v.value) : []);
  };

  return (
    <Select
      isMulti
      options={options}
      value={selectedOptions}
      onChange={handleChange}
      menuPortalTarget={document.body}
      menuPosition="fixed"
      styles={{ ...selectStyles, ...styles }}
      {...props}
    />
  );
};

export default MultiSelect;
